import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {UrlQueryService} from '../../../../common/url-query/url-query.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OperatorsSettingsApiService {

  constructor(private http: HttpClient) {}

  private readonly operatorsUrl: string = 'security/operator';

  public getOperators(params: object = {}): Observable<any> {
    const generatedOperatorsUrl = UrlQueryService.addQueryParameters(this.operatorsUrl, params);

    return this.http.get(generatedOperatorsUrl);
  }

  public addOperator(operator): Observable<any> {
    return this.http.post(this.operatorsUrl, operator);
  }

  public updateOperator(operator): Observable<any> {
    return this.http.put(`${this.operatorsUrl}/${operator.id}`, operator);
  }

  public deleteOperator(operatorId): Observable<any> {
    return this.http.delete(`${this.operatorsUrl}/${operatorId}`);
  }

  public changePassword(operator): Observable<any> {
    return this.http.put(`${this.operatorsUrl}/changePassword`, operator);
  }
}
